export function subtractDays(dateLike, days) {
  const d = new Date(dateLike);
  if (Number.isNaN(d.getTime())) return "";
  d.setDate(d.getDate() - days);
  return toDatetimeLocalValue(d);
}

export function toDatetimeLocalValue(dateLike) {
  if (!dateLike) return "";
  const d = new Date(dateLike);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  const yyyy = d.getFullYear();
  const mm = pad(d.getMonth() + 1);
  const dd = pad(d.getDate());
  const hh = pad(d.getHours());
  const mi = pad(d.getMinutes());
  return `${yyyy}-${mm}-${dd}T${hh}:${mi}`;
}
